<div class="d-flex flex-column gap-3">
  <section class="bg-white rounded-4 border shadow-sm p-3 p-md-4">
    <div class="d-flex align-items-start justify-content-between gap-3 flex-wrap mb-3">
      <div>
        <h2 class="fw-bold fs-5 mb-1">Configure Docuseal Template</h2>
        <p class="text-secondary text-xs mb-0">
          Load template fields and roles for Docuseal tagging.
        </p>
      </div>
    </div>

    <div class="row g-3 mb-3">
      <div class="col-12 col-md-4">
        <div class="text-xxs text-uppercase text-secondary fw-bold">Template ID</div>
        <div class="text-xs fw-semibold">{{ template_id || '-' }}</div>
      </div>
      <div class="col-12 col-md-4">
        <div class="text-xxs text-uppercase text-secondary fw-bold">Template Entity Type ID</div>
        <div class="text-xs fw-semibold">{{ template_entity_type_id || '-' }}</div>
      </div>
      <div class="col-12 col-md-4">
        <div class="text-xxs text-uppercase text-secondary fw-bold">Onboarding Form ID</div>
        <div class="text-xs fw-semibold">{{ onboarding_form_id || '-' }}</div>
      </div>
    </div>

    <div v-if="loading" class="alert alert-light text-xs border mb-3">
      Loading Docuseal configuration...
    </div>
    <div v-else-if="missing_setup_reason" class="alert alert-warning text-xs mb-3">
      {{ missing_setup_reason }}
    </div>

    <div v-if="token" class="border rounded-4 p-2 bg-light">
      <DocusealBuilder
        :key="builder_key"
        :token="token"
        :only-defined-fields="false"
        :with-title="false"
        :with-send-button="false"
        :with-sign-yourself-button="false"
        :with-upload-button="false"
        :with-documents-list="false"
        :fields="defined_fields"
        :roles="builder_roles"
        @fields-update="on_fields_update"
      ></DocusealBuilder>
    </div>
    <div class="alert alert-info text-xs mb-0" v-else-if="!loading">
      Docuseal token was not returned by the API.
    </div>
  </section>
</div>
